import { render, staticRenderFns } from "./titlenav.vue?vue&type=template&id=4fcc8747&scoped=true&"
import script from "./titlenav.vue?vue&type=script&lang=js&"
export * from "./titlenav.vue?vue&type=script&lang=js&"
import style0 from "./titlenav.vue?vue&type=style&index=0&id=4fcc8747&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcc8747",
  null
  
)

export default component.exports